import { Book } from "@app/types";
import Slider, { Settings } from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./style.scss";

type ComingSoonProps = {
  books: Book[];
};

const settings: Settings = {
  dots: true,
  infinite: false,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 3,
  pauseOnHover: true,
  pauseOnFocus: true,
  pauseOnDotsHover: true,
  autoplay: true,
  autoplaySpeed: 5000,
  focusOnSelect: false,
};

function ComingSoon({ books }: ComingSoonProps) {
  return (
    <div className="slider-container">
      <Slider
        {...settings}
        className="[&_.slick-track]:flex [&_.slick-track]:gap-10"
      >
        {books.map((item) => (
          <div key={item.id}>
            <img
              className="w-[386px] h-[580px] rounded-[16px]"
              src={item.thumbnails[0]}
              alt=""
            />
          </div>
        ))}
      </Slider>
    </div>
  );
}

export default ComingSoon;
